import React, { useState, useRef, useEffect } from 'react';
import i18n from '../i18n/config';
import { useTranslation } from 'react-i18next';
import { FaChevronDown } from 'react-icons/fa6';

const SwitchLang = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    const currentLang = i18n.language;

    const validLang = ['en', 'zh-CN', 'zh-HK'].includes(currentLang)
        ? currentLang
        : 'zh-CN';

    const selectedLabel = {
        en: 'EN',
        'zh-CN': '简',
        'zh-HK': '繁',
    };

    const options = [
        {
            value: 'en',
            label: 'English',
        },
        {
            value: 'zh-CN',
            label: '中文（简体）',
        },
        {
            value: 'zh-HK',
            label: '中文（繁体）',
        },
    ];

    const changeLanguage = (lang) => {
        localStorage.setItem('lang', lang);
        i18n.changeLanguage(lang);
        setIsOpen(false);
    };

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div ref={containerRef} className="relative flex items-center flex-shrink-0 div-lang select-none">
            <button
                type="button"
                onClick={() => setIsOpen((prev) => !prev)}
                className="flex items-center justify-between bg-white border border-[#d9d9d9] hover:border-[#4096ff] rounded-md px-2 transition-all cursor-pointer focus:outline-none"
                style={{
                    width: '62px',
                    height: '32px',
                    backgroundColor: '#ffffff',
                    border: '1px solid #d9d9d9',
                    borderRadius: '6px',
                    padding: '0 8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    boxSizing: 'border-box',
                }}
                aria-label="Language Selector"
                aria-expanded={isOpen}
            >
                <span
                    className="font-medium text-gray-800 text-sm"
                    style={{ fontSize: '14px', fontWeight: 500, color: '#1f2937', lineHeight: 1 }}
                >
                    {selectedLabel[validLang] || '简'}
                </span>
                <FaChevronDown
                    className={`text-[10px] text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                    style={{ fontSize: '10px', color: '#9ca3af', marginLeft: '4px' }}
                />
            </button>

            {isOpen && (
                <div
                    className="absolute right-0 top-[calc(100%+4px)] bg-white rounded-lg shadow-lg border border-gray-100 py-1 min-w-[125px] z-[1050]"
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: 'calc(100% + 4px)',
                        backgroundColor: '#ffffff',
                        borderRadius: '8px',
                        boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
                        border: '1px solid #f0f0f0',
                        padding: '4px 0',
                        minWidth: '125px',
                        zIndex: 1050,
                    }}
                >
                    {options.map((opt) => (
                        <div
                            key={opt.value}
                            onClick={() => changeLanguage(opt.value)}
                            className={`px-3 py-2 text-sm cursor-pointer transition-colors flex items-center ${
                                validLang === opt.value
                                    ? 'bg-blue-50 text-blue-600 font-medium'
                                    : 'text-gray-700 hover:bg-gray-50'
                            }`}
                            style={{
                                padding: '8px 12px',
                                fontSize: '14px',
                                cursor: 'pointer',
                                backgroundColor: validLang === opt.value ? '#e6f4ff' : 'transparent',
                                color: validLang === opt.value ? '#1677ff' : '#374151',
                                fontWeight: validLang === opt.value ? 600 : 400,
                            }}
                        >
                            {opt.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SwitchLang;
